
export default function initServiceWorker() {
    new Promise((resolve, reject) => {
        Notification.requestPermission().then(result => {
            if (result === 'granted') {
                resolve();
            } else {
                reject('Permission denied by the user');
            }
        });
    });

    navigator.serviceWorker.register("/service-worker.js", { type: 'module' })
        .then(() => navigator.serviceWorker.ready)
        .then((registration) => {
            registration.active.postMessage({ type: 'INIT_WS' });
        })
        .catch(err => {
            console.error("Error while registering service worker", err);
        });
}